import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadZoneByIdFailed, loadZoneByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadZoneById(action) {
  try {
    const url = `${BACKEND_URL}/zones/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadZoneByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadZoneByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadZoneByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
